import { useLanguage } from "../../../i18n/LanguageContext";

export default function DrugClassBlock({ block }) {
  const { language } = useLanguage();

  const content = block.content || {};
  const translated = block.translated_content || {};

  const getTranslation = (chineseValue, translatedValue) => {
    if (language === "zh") {
      return chineseValue || null;
    }

    if (language === "es" || language === "ru") {
      return translatedValue || null;
    }

    return null;
  };

  const nameTranslation = getTranslation(
    content.name_zh,
    translated.name
  );

  const mechanismTranslation = getTranslation(
    content.mechanism_zh,
    translated.mechanism
  );

  const examplesTranslation = getTranslation(
    content.examples_zh,
    translated.examples
  );

  return (
    <div
      style={{
        padding: "20px",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        backgroundColor: "#ffffff",
        marginBottom: "14px",
      }}
    >
      {/* Canonical English name */}
      <div
        style={{
          fontSize: "20px",
          fontWeight: "700",
        }}
      >
        {content.name_en}
      </div>

      {/* Selected-language name */}
      {nameTranslation && (
        <div
          style={{
            color: "#6b7280",
            marginTop: "4px",
            marginBottom: "18px",
          }}
        >
          {nameTranslation}
        </div>
      )}

      <div style={{ marginBottom: "16px" }}>
        <strong>Purpose / Mechanism</strong>

        {/* Canonical English */}
        {content.mechanism_en && (
          <div
            style={{
              marginTop: "6px",
              lineHeight: "1.6",
            }}
          >
            {content.mechanism_en}
          </div>
        )}

        {/* Selected-language learning aid */}
        {mechanismTranslation && (
          <div
            style={{
              marginTop: "4px",
              color: "#6b7280",
              lineHeight: "1.6",
            }}
          >
            {mechanismTranslation}
          </div>
        )}
      </div>

      {content.examples_en &&
        content.examples_en !== "--" && (
          <div>
            <strong>Examples</strong>

            <div
              style={{
                marginTop: "6px",
                lineHeight: "1.6",
              }}
            >
              {content.examples_en}
            </div>

            {examplesTranslation &&
              examplesTranslation !== "--" && (
                <div
                  style={{
                    marginTop: "4px",
                    color: "#6b7280",
                    lineHeight: "1.6",
                  }}
                >
                  {examplesTranslation}
                </div>
              )}
          </div>
        )}
    </div>
  );
}